import { ready } from "./utils.js";

ready(() => {
  const header = document.getElementsByTagName("header")[0];
  const logoImg = header.querySelector(".logo");

  function updateHeaderScrollClasses() {
    const scrollY = window.scrollY;
    if (scrollY > 150) {
      header.classList.add("small");
      logoImg.src = "/assets/Dateien/logo-black.svg";
    } else if (scrollY < 10) {
      header.classList.remove("small");
      logoImg.src = "/assets/Dateien/logo.svg";
    }
  }
  
  if (header) {
    document.addEventListener("scroll", updateHeaderScrollClasses); //on scroll
    //updateHeaderScrollClasses(); //after reload
  }
});

